/* =========================================================
   MF Styling Videos — assets/mf-reels.js
   Entry points (all fed by the product metafield custom.styling_videos via snippets/mf-sv-items.liquid):
     [data-mf-sv="float"]  product page floating video card -> full-screen player (dialog)
     [data-mf-feed]        Reels page: full-screen vertical feed that autoplays (TikTok / Reels style)
   ========================================================= */
(function () {
  'use strict';
  if (window.MFReels) return;

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var MOBILE = window.matchMedia('(max-width: 749px)');
  var MUTE_KEY = 'mf_rp_muted', DISMISS_KEY = 'mf_svf_dismissed';
  function $(r, s) { return r.querySelector(s); }
  function $$(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function items(el) {
    var s = el && $(el, '[data-mf-sv-items]');
    try { return (JSON.parse(s.textContent) || []).filter(function (x) { return x && x.src; }); } catch (e) { return []; }
  }
  function pauseOthers(except) {
    $$(document, 'video').forEach(function (v) { if (v !== except && !v.paused && !v.hasAttribute('data-mf-keep')) { try { v.pause(); } catch (e) {} } });
  }

  /* ================= Player ================= */
  var P = null;
  function Player() {
    var dlg = $(document, '[data-mf-rp]');
    if (!dlg || typeof dlg.showModal !== 'function') return null;
    var video = $(dlg, '[data-mf-rp-video]'), poster = $(dlg, '[data-mf-rp-poster]'), stage = $(dlg, '[data-mf-rp-stage]');
    var spin = $(dlg, '[data-mf-rp-spin]'), state = $(dlg, '[data-mf-rp-state]');
    var count = $(dlg, '[data-mf-rp-count]'), mute = $(dlg, '[data-mf-rp-mute]'), live = $(dlg, '[data-mf-rp-live]');
    var card = $(dlg, '[data-mf-rp-card]'), cimg = $(dlg, '[data-mf-rp-cimg]'), cname = $(dlg, '[data-mf-rp-cname]');
    var cprice = $(dlg, '[data-mf-rp-cprice]'), ccomp = $(dlg, '[data-mf-rp-ccompare]'), coff = $(dlg, '[data-mf-rp-coff]');
    var clink = $(dlg, '[data-mf-rp-clink]'), catc = $(dlg, '[data-mf-rp-catc]');
    var list = [], i = 0, opener = null, pushed = false, closing = false;
    var muted = ss(MUTE_KEY) !== '0';
    var here = (location.pathname || '').replace(/\/$/, '');

    function setMute(m) {
      muted = m; video.muted = m; ss(MUTE_KEY, m ? '1' : '0');
      mute.setAttribute('aria-pressed', m ? 'true' : 'false');
      mute.setAttribute('aria-label', m ? 'Unmute' : 'Mute');
      dlg.classList.toggle('is-muted', m);
    }
    function onThisProduct(url) {
      if (!url) return false;
      var a = document.createElement('a'); a.href = url;
      var p = a.pathname.replace(/\/$/, '');
      return here === p || here.slice(-p.length) === p && /\/products\//.test(here);
    }
    function fillCard(pr) {
      if (!pr) { card.hidden = true; return; }
      card.hidden = false;
      cimg.src = pr.image || ''; cimg.hidden = !pr.image;
      cname.textContent = pr.vendor ? pr.vendor + ' \u00b7 ' + pr.title : pr.title;
      cprice.textContent = pr.price || '';
      ccomp.textContent = pr.compare || ''; ccomp.hidden = !pr.compare;
      coff.textContent = pr.pct > 0 ? '-' + pr.pct + '%' : ''; coff.hidden = !(pr.pct > 0);
      var same = onThisProduct(pr.url);
      clink.href = pr.url; clink.hidden = same;
      clink.setAttribute('aria-label', 'View ' + pr.title);
      // already on this product: offer Add to Cart (uses the page's own button and its size checks)
      var pageAtc = same && $(document, 'form[data-type="add-to-cart-form"] [data-mf-atc], .mf-bar [data-mf-atc]');
      catc.hidden = !(same && pageAtc && pr.available);
    }
    function show(n, dir) {
      if (!list.length) return;
      i = (n + list.length) % list.length;
      var it = list[i];
      stage.classList.remove('is-in-next', 'is-in-prev');
      if (dir && !RM.matches) { void stage.offsetWidth; stage.classList.add(dir > 0 ? 'is-in-next' : 'is-in-prev'); }
      poster.src = it.poster || ''; poster.hidden = !it.poster;
      dlg.classList.remove('is-playing'); dlg.classList.add('is-loading');
      video.pause();
      video.poster = it.poster || '';
      video.src = it.src;
      video.muted = muted;
      var pr = video.play();
      if (pr && pr.catch) pr.catch(function () { dlg.classList.add('is-paused'); });
      count.textContent = list.length > 1 ? (i + 1) + ' / ' + list.length : '';
      dlg.classList.toggle('is-single', list.length < 2);
      fillCard(it.product);
      live.textContent = 'Video ' + (i + 1) + ' of ' + list.length + (it.product ? ': ' + it.product.title : '');
      var nx = list[(i + 1) % list.length];                 // warm the next poster only (never the next video)
      if (nx && nx.poster) { var im = new Image(); im.src = nx.poster; }
    }
    function toggle() {
      if (video.paused) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
      else video.pause();
    }
    video.addEventListener('playing', function () { dlg.classList.add('is-playing'); dlg.classList.remove('is-loading', 'is-paused'); });
    video.addEventListener('waiting', function () { dlg.classList.add('is-loading'); });
    video.addEventListener('pause', function () { dlg.classList.remove('is-playing'); dlg.classList.add('is-paused'); });
    video.addEventListener('play', function () { dlg.classList.remove('is-paused'); pauseOthers(video); });

    function open(l, n, from) {
      if (!l || !l.length) return;
      list = l; opener = from || document.activeElement;
      setMute(muted);
      if (!dlg.open) {
        pauseOthers(null);
        dlg.showModal();
        document.documentElement.classList.add('mf-rp-lock');
        requestAnimationFrame(function () { dlg.classList.add('is-open'); });
        try { history.pushState({ mfrp: 1 }, ''); pushed = true; } catch (e) { pushed = false; }
      }
      show(n || 0, 0);
      setTimeout(function () { var c = $(dlg, '[data-mf-rp-close]'); if (c) c.focus({ preventScroll: true }); }, 40);
    }
    function finish() {
      closing = false;
      video.pause(); video.removeAttribute('src'); try { video.load(); } catch (e) {}
      if (dlg.open) dlg.close();
      dlg.classList.remove('is-open', 'is-playing', 'is-loading', 'is-paused');
      document.documentElement.classList.remove('mf-rp-lock');
      document.dispatchEvent(new CustomEvent('mf:reels:close'));
      if (opener && opener.focus) opener.focus({ preventScroll: true });
    }
    function close(fromHistory) {
      if (!dlg.open || closing) return;
      closing = true;
      dlg.classList.remove('is-open');
      if (pushed && !fromHistory) { pushed = false; try { history.back(); } catch (e) {} }
      pushed = fromHistory ? false : pushed;
      setTimeout(finish, RM.matches ? 0 : 220);
    }
    window.addEventListener('popstate', function () { if (dlg.open) { pushed = false; close(true); } });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    $(dlg, '[data-mf-rp-close]').addEventListener('click', function () { close(); });
    mute.addEventListener('click', function (e) { e.stopPropagation(); setMute(!muted); if (!muted && video.paused) toggle(); });
    $(dlg, '[data-mf-rp-prev]').addEventListener('click', function () { show(i - 1, -1); });
    $(dlg, '[data-mf-rp-next]').addEventListener('click', function () { show(i + 1, 1); });
    catc.addEventListener('click', function () {
      var btn = $(document, 'form[data-type="add-to-cart-form"] [data-mf-atc]');
      var bar = $(document, '.mf-bar.is-on [data-mf-atc]');
      var target = (MOBILE.matches && bar) ? bar : (btn && btn.offsetParent ? btn : bar || btn);
      close();
      setTimeout(function () { if (target) target.click(); }, RM.matches ? 0 : 240);   // page validates size, then adds
    });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); show(i + 1, 1); }
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); show(i - 1, -1); }
      else if (e.key === ' ' && e.target === dlg) { e.preventDefault(); toggle(); }
      else if (e.key === 'm' || e.key === 'M') setMute(!muted);
    });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });   // desktop: click on the dark area

    // tap = play/pause; swipe up/left = next, down/right = previous
    var t = null;
    stage.addEventListener('pointerdown', function (e) { if (!e.isPrimary) return; t = { x: e.clientX, y: e.clientY, at: Date.now() }; });
    stage.addEventListener('pointerup', function (e) {
      if (!t) return;
      var dx = e.clientX - t.x, dy = e.clientY - t.y, ax = Math.abs(dx), ay = Math.abs(dy);
      t = null;
      if (ax < 10 && ay < 10) { toggle(); return; }
      if (list.length < 2) return;
      if (ay > ax && ay > 50) show(i + (dy < 0 ? 1 : -1), dy < 0 ? 1 : -1);
      else if (ax > 50) show(i + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
    });
    stage.addEventListener('pointercancel', function () { t = null; });
    document.addEventListener('visibilitychange', function () { if (document.hidden && dlg.open) video.pause(); });

    return { open: open, close: close, el: dlg };
  }
  function player() { if (!P) P = Player(); return P; }

  /* ================= Entry points ================= */
  function bindOpeners(el, list) {
    $$(el, '[data-mf-sv-open]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        var p = player(); if (!p) return;
        e.preventDefault();
        p.open(list, parseInt(b.getAttribute('data-mf-sv-open'), 10) || 0, b);
      });
    });
  }

  function Float(el, list) {
    if (!list.length || ss(DISMISS_KEY) === '1') { el.remove(); return; }
    var btn = $(el, '[data-mf-sv-open]'), x = $(el, '[data-mf-svf-x]'), prev = $(el, '[data-mf-svf-video]');
    el.hidden = false;

    // bottom = same as the WhatsApp button, but always above the Add to Cart bar / bottom nav
    function place() {
      var vh = window.innerHeight, minBottom = 16;
      var bar = $(document, '.mf-bar.is-on');
      if (bar && getComputedStyle(bar).display !== 'none') minBottom = Math.max(minBottom, vh - bar.getBoundingClientRect().top + 12);
      var nav = $(document, '.mf-bnav, [data-mf-bnav]');
      if (nav && getComputedStyle(nav).position === 'fixed' && nav.offsetHeight) minBottom = Math.max(minBottom, vh - nav.getBoundingClientRect().top + 12);
      var wa = findWhatsApp(), b = minBottom;
      if (wa) b = Math.max(minBottom, vh - wa.getBoundingClientRect().bottom);
      el.style.bottom = Math.round(b) + 'px';
    }
    function findWhatsApp() {
      var c = $$(document, 'a[href*="wa.me"], a[href*="whatsapp"], [class*="whatsapp" i], [id*="whatsapp" i]');
      for (var k = 0; k < c.length; k++) {
        var n = c[k], hops = 0;
        while (n && n !== document.body && hops < 6) {
          var cs = getComputedStyle(n);
          if (cs.position === 'fixed') { var r = n.getBoundingClientRect(); if (r.width > 20 && r.width < 140 && r.left > window.innerWidth / 2) return n; break; }
          n = n.parentElement; hops++;
        }
      }
      return null;
    }
    place();
    window.addEventListener('resize', place);
    window.addEventListener('scroll', function () { requestAnimationFrame(place); }, { passive: true });
    var tries = 0, iv = setInterval(function () { place(); if (++tries > 12) clearInterval(iv); }, 800);   // chat apps load late

    // tiny muted preview, loaded after the page has finished loading
    var it = list[0];
    function startPreview() {
      if (!prev || RM.matches || (navigator.connection && navigator.connection.saveData)) return;
      prev.src = it.small || it.src;
      var p = prev.play(); if (p && p.catch) p.catch(function () {});
    }
    if (document.readyState === 'complete') setTimeout(startPreview, 1200);
    else window.addEventListener('load', function () { setTimeout(startPreview, 1200); });
    document.addEventListener('visibilitychange', function () { if (!prev || !prev.src) return; if (document.hidden) prev.pause(); else prev.play().catch(function () {}); });
    document.addEventListener('mf:reels:close', function () { if (prev && prev.src) prev.play().catch(function () {}); });
    if (btn) btn.addEventListener('click', function () { if (prev) prev.pause(); });

    x.addEventListener('click', function () {
      ss(DISMISS_KEY, '1');
      if (prev) { prev.pause(); prev.removeAttribute('src'); }
      el.classList.add('is-gone');
      setTimeout(function () { el.remove(); }, 200);
    });
  }


  /* ================= Reels page: vertical autoplay feed =================
     Three recycled slides (previous / current / next) move with transforms, so the feed is smooth,
     loops from the last reel to the first, and only the current + next video are ever loaded. */
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function Feed(root) {
    var track = $(root, '[data-mf-feed-track]');
    var list = items(root);
    var empty = $(root, '[data-mf-feed-empty]');
    var muteBtn = $(root, '[data-mf-feed-mute]'), live = $(root, '[data-mf-feed-live]');
    var nextUrl = root.getAttribute('data-next-url') || '';
    var sectionId = root.getAttribute('data-section-id') || '';
    if (!list.length) { if (empty) empty.hidden = false; root.classList.add('is-empty'); return; }
    root.classList.add('is-ready');
    document.documentElement.classList.add('mf-feed-page');

    var muted = ss(MUTE_KEY) !== '0';
    var i = 0, busy = false, loadingMore = false;
    var start = (location.search.match(/[?&]v=([^&]+)/) || [])[1];
    if (start) { for (var k = 0; k < list.length; k++) if (String(list[k].id) === decodeURIComponent(start)) { i = k; break; } }

    function mk() {
      var el = document.createElement('div');
      el.className = 'mf-feed__slide';
      el.innerHTML =
        '<img class="mf-feed__poster" alt="" decoding="async">' +
        '<video class="mf-feed__video" playsinline webkit-playsinline muted preload="none"></video>' +
        '<span class="mf-feed__spin" aria-hidden="true"></span>' +
        '<span class="mf-feed__state" aria-hidden="true"><svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor" focusable="false"><path d="M8 5v14l11-7z"/></svg></span>' +
        '<a class="mf-feed__card" href="#">' +
          '<img class="mf-feed__cimg" alt="" width="48" height="64">' +
          '<span class="mf-feed__ctxt"><span class="mf-feed__cname"></span><span class="mf-feed__cprice"></span></span>' +
          '<span class="mf-feed__cgo" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" focusable="false"><path d="M9 5l7 7-7 7"/></svg></span>' +
        '</a>';
      track.appendChild(el);
      var v = $(el, 'video');
      v.addEventListener('playing', function () { el.classList.add('is-playing'); el.classList.remove('is-loading', 'is-paused'); });
      v.addEventListener('waiting', function () { el.classList.add('is-loading'); });
      v.addEventListener('pause', function () { el.classList.remove('is-playing'); if (el === S[1]) el.classList.add('is-paused'); });
      v.addEventListener('ended', function () { if (el === S[1]) go(1); });
      return el;
    }
    var S = [mk(), mk(), mk()];                         // [previous, current, next]
    function item(n) { return list[((n % list.length) + list.length) % list.length]; }
    function fill(el, it, load) {
      if (!it) return;
      if (el.__id !== it.id) {
        el.__id = it.id;
        var v = $(el, 'video'), pimg = $(el, '.mf-feed__poster');
        v.pause(); v.removeAttribute('src'); try { v.load(); } catch (e) {}
        v.poster = it.poster || ''; pimg.src = it.poster || ''; pimg.hidden = !it.poster;
        el.classList.remove('is-playing', 'is-paused'); el.__src = it.src;
        var pr = it.product || {}, card = $(el, '.mf-feed__card');
        card.hidden = !pr.url; card.href = pr.url || '#';
        card.setAttribute('aria-label', 'View ' + (pr.title || 'product') + ', ' + (pr.price || ''));
        var ci = $(el, '.mf-feed__cimg'); ci.src = pr.image || ''; ci.hidden = !pr.image;
        $(el, '.mf-feed__cname').textContent = pr.vendor ? pr.vendor + ' \u00b7 ' + pr.title : (pr.title || '');
        $(el, '.mf-feed__cprice').innerHTML = esc(pr.price) + (pr.compare ? ' <s>' + esc(pr.compare) + '</s>' : '') +
          (pr.pct > 0 ? ' <span class="mf-feed__off">-' + pr.pct + '%</span>' : '');
      }
      var vid = $(el, 'video');
      if (load && !vid.getAttribute('src')) { vid.preload = 'auto'; vid.src = el.__src; }   // current + next only
    }
    function place(off, anim) {
      var h = track.clientHeight || window.innerHeight;
      S.forEach(function (el, k) {
        el.style.transition = anim && !RM.matches ? 'transform .32s cubic-bezier(.22,.8,.24,1)' : 'none';
        el.style.transform = 'translate3d(0,' + ((k - 1) * h + off) + 'px,0)';
        el.setAttribute('aria-hidden', k === 1 ? 'false' : 'true');
        $(el, '.mf-feed__card').tabIndex = k === 1 ? 0 : -1;
      });
    }
    function playCurrent() {
      var cur = S[1], v = $(cur, 'video');
      [S[0], S[2]].forEach(function (el) { var o = $(el, 'video'); if (!o.paused) o.pause(); if (o.getAttribute('src')) try { o.currentTime = 0; } catch (e) {} el.classList.remove('is-paused'); });
      fill(cur, item(i), true);
      v.loop = list.length === 1;
      v.muted = muted;
      cur.classList.add('is-loading');
      var p = v.play();
      if (p && p.catch) p.catch(function () { cur.classList.remove('is-loading'); cur.classList.add('is-paused'); });
      if (list.length > 1) fill(S[2], item(i + 1), true);     // preload only the next reel
      var pr = item(i).product || {};
      if (live) live.textContent = 'Reel ' + (i + 1) + ' of ' + list.length + (pr.title ? ': ' + pr.title : '');
      maybeMore();
    }
    function go(dir) {
      if (busy || list.length < 2) return;
      busy = true;
      var h = track.clientHeight || window.innerHeight;
      place(-dir * h, true);
      setTimeout(function () {
        if (dir > 0) { S = [S[1], S[2], S[0]]; i = (i + 1) % list.length; fill(S[2], item(i + 1), false); }
        else { S = [S[2], S[0], S[1]]; i = (i - 1 + list.length) % list.length; fill(S[0], item(i - 1), false); }
        place(0, false);
        playCurrent();
        busy = false;
      }, RM.matches ? 0 : 330);
    }
    function setMute(m) {
      muted = m; ss(MUTE_KEY, m ? '1' : '0');
      S.forEach(function (el) { $(el, 'video').muted = m; });
      root.classList.toggle('is-muted', m);
      muteBtn.setAttribute('aria-pressed', m ? 'true' : 'false');
      muteBtn.setAttribute('aria-label', m ? 'Unmute' : 'Mute');
    }
    function toggle() { var v = $(S[1], 'video'); if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); }

    // more products than one page: load the next page of the Reels section when near the end
    function maybeMore() {
      if (!nextUrl || loadingMore || i < list.length - 3) return;
      loadingMore = true;
      var u = nextUrl + (nextUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
      fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html'), f = doc.querySelector('[data-mf-feed]');
        if (!f) { nextUrl = ''; return; }
        var more = items(f);
        nextUrl = f.getAttribute('data-next-url') || '';
        if (more.length) { list = list.concat(more); fill(S[2], item(i + 1), true); }
      }).catch(function () { nextUrl = ''; }).then(function () { loadingMore = false; });
    }

    // gestures: drag up/down, tap to pause
    var t = null;
    track.addEventListener('pointerdown', function (e) {
      if (!e.isPrimary || e.target.closest('.mf-feed__card') || busy) return;
      t = { y: e.clientY, x: e.clientX, at: performance.now(), moved: false };
      try { track.setPointerCapture(e.pointerId); } catch (err) {}
    });
    track.addEventListener('pointermove', function (e) {
      if (!t) return;
      var dy = e.clientY - t.y;
      if (!t.moved && Math.abs(dy) < 8) return;
      t.moved = true;
      if (list.length > 1) place(dy, false);
    });
    function up(e) {
      if (!t) return;
      var dy = e.clientY - t.y, dt = performance.now() - t.at, moved = t.moved;
      t = null;
      if (!moved) { toggle(); return; }
      var h = track.clientHeight, fast = Math.abs(dy) / Math.max(1, dt) > 0.5 && Math.abs(dy) > 30;
      if (list.length > 1 && (Math.abs(dy) > h * 0.18 || fast)) go(dy < 0 ? 1 : -1);
      else place(0, true);
    }
    track.addEventListener('pointerup', up);
    track.addEventListener('pointercancel', function () { t = null; place(0, true); });
    // desktop: wheel, keys, buttons
    var wheelLock = 0;
    root.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) < 12) return;
      e.preventDefault();
      var now = Date.now(); if (now < wheelLock) return;
      wheelLock = now + 650; go(e.deltaY > 0 ? 1 : -1);
    }, { passive: false });
    document.addEventListener('keydown', function (e) {
      if (/input|textarea|select/i.test((e.target && e.target.tagName) || '')) return;
      if (e.key === 'ArrowDown' || e.key === 'PageDown') { e.preventDefault(); go(1); }
      else if (e.key === 'ArrowUp' || e.key === 'PageUp') { e.preventDefault(); go(-1); }
      else if (e.key === ' ' && !e.target.closest('a,button')) { e.preventDefault(); toggle(); }
      else if (e.key === 'm' || e.key === 'M') setMute(!muted);
    });
    var upB = $(root, '[data-mf-feed-prev]'), dnB = $(root, '[data-mf-feed-next]'), back = $(root, '[data-mf-feed-back]');
    if (upB) upB.addEventListener('click', function () { go(-1); });
    if (dnB) dnB.addEventListener('click', function () { go(1); });
    if (back) back.addEventListener('click', function (e) {
      if (document.referrer && document.referrer.indexOf(location.host) > -1 && history.length > 1) { e.preventDefault(); history.back(); }
    });
    muteBtn.addEventListener('click', function () { setMute(!muted); if (!muted) { var v = $(S[1], 'video'); if (v.paused) toggle(); } });
    document.addEventListener('visibilitychange', function () { var v = $(S[1], 'video'); if (document.hidden) v.pause(); else if (!S[1].classList.contains('is-paused')) v.play().catch(function () {}); });
    window.addEventListener('resize', function () { place(0, false); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) playCurrent(); });

    if (list.length < 2) root.classList.add('is-single');
    setMute(muted);
    fill(S[0], item(i - 1), false);
    fill(S[1], item(i), true);
    place(0, false);
    playCurrent();
  }

  function init() {
    $$(document, '[data-mf-sv]').forEach(function (el) {
      if (el.__mfsv) return; el.__mfsv = true;
      var list = items(el), kind = el.getAttribute('data-mf-sv');
      if (!list.length) { el.remove(); return; }
      if (kind === 'float') Float(el, list);
      bindOpeners(el, list);
    });
    $$(document, '[data-mf-feed]').forEach(function (el) { if (!el.__mffeed) { el.__mffeed = true; Feed(el); } });
  }

  window.MFReels = { open: function (list, n, from) { var p = player(); if (p) p.open(list, n, from); }, init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();